var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8071_41124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44058 14.933C7.52592 14.8472 7.64328 14.7971 7.76774 14.7971H19.055C19.2613 14.7971 19.3644 15.0474 19.2186 15.1939L16.9889 17.4354C16.9035 17.5212 16.7862 17.5712 16.6617 17.5712H5.37445C5.16819 17.5712 5.06506 17.321 5.21086 17.1744L7.44058 14.933Z",
    fill: "url(#paint0_linear_8071_41124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44058 6.56431C7.52948 6.47851 7.64683 6.42847 7.76774 6.42847H19.055C19.2613 6.42847 19.3644 6.67871 19.2186 6.82528L16.9889 9.06672C16.9035 9.15251 16.7862 9.20256 16.6617 9.20256H5.37445C5.16819 9.20256 5.06506 8.95232 5.21086 8.80575L7.44058 6.56431Z",
    fill: "url(#paint1_linear_8071_41124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9889 10.7218C16.9035 10.636 16.7862 10.5859 16.6617 10.5859H5.37445C5.16819 10.5859 5.06506 10.8362 5.21086 10.9827L7.44058 13.2242C7.52592 13.31 7.64328 13.36 7.76774 13.36H19.055C19.2613 13.36 19.3644 13.1098 19.2186 12.9632L16.9889 10.7218Z",
    fill: "url(#paint2_linear_8071_41124)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8071_41124",
    x1: 17.9767,
    y1: 5.08938,
    x2: 10.1005,
    y2: 20.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8071_41124",
    x1: 14.561,
    y1: 3.29683,
    x2: 6.68477,
    y2: 18.3041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8071_41124",
    x1: 16.258,
    y1: 4.18736,
    x2: 8.38174,
    y2: 19.1947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8071_41124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1429,
    height: 11.1429,
    fill: "white",
    transform: "translate(5.14258 6.42847)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.f7f070ae4219f531e07e1b3596a5703c.svg";
export { ForwardRef as ReactComponent };